import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {LogType} from "@/store/player/types";
import DropDownList from "phaser3-rex-plugins/templates/ui/dropdownlist/DropDownList";
import SpriteUtils from "@/utils/sprite-utils";
import {Container} from "inversify";
import {PlayerHistorySettings} from "@/scenes.ui/player-history-settings";
import BaseGeom from "phaser3-rex-plugins/plugins/gameobjects/shape/shapes/geoms/base/BaseGeom";
import {Keys} from "@/constants/key";

export class SimpleDropDownList extends Phaser.GameObjects.Container  {

    private chooseButton!: Phaser.GameObjects.Sprite;
    private chooseButtonText!: Phaser.GameObjects.Text;
    private options: Map<string, Phaser.GameObjects.Text> = new Map<string, Phaser.GameObjects.Text>();
    private optionsBg: Map<string, Phaser.GameObjects.Sprite> = new Map<string, Phaser.GameObjects.Sprite>();
    private chosen!: string;

    constructor(scene:Scene, canvas:HTMLCanvasElement, x:number, y:number, values: string[], isGray:boolean, defaultValueIndex?: number | undefined,
                startChooseCallback?: () => unknown, endChooseCallback?: () => unknown) {
        super(scene, x, y);
        let self = this;

        if(defaultValueIndex == undefined){
            values.unshift("");
        } else {
            this.chosen = values[defaultValueIndex];
        }

        let yy = 0;

        if(isGray){
            self.chooseButton = SpriteUtils.addSprite(scene, 0, yy, Keys.UI_LANG_BUTT_AVAL, undefined, 1, 1);
        } else {
            self.chooseButton = SpriteUtils.addSprite(scene, 0, yy, Keys.ATLAS_UI, Keys.UI_BUTTON_BROWN, 1, 0.5);
        }
        self.chooseButtonText = TextUtils.addTextByFamily(scene, this.formatUtilText(Tr('vibrat')), 0, yy,
            '#d5d3d3', 15, 'normal', 300, Fonts.MYRIADPRO_REGULAR);
        self.chooseButton.setInteractive().on('pointerup', function() {
            self.options.forEach( (text, key) => {
                text.visible = true;
            });
            self.optionsBg.forEach( (bg, key) => {
                bg.visible = true;
            });
            self.chooseButton.visible = false;
            self.chooseButton.alpha = isGray? 1 : 0.5;
            self.chooseButtonText.visible = false;
            if(startChooseCallback) startChooseCallback();
        });
        self.chooseButton.alpha = isGray? 1 : 0.5;

        if(this.chosen){
            self.chooseButtonText.text = this.chosen;
        }

        self.add([self.chooseButton, self.chooseButtonText]);

        let textColor = isGray? '#ffffff': '#98ff9f';

        values.forEach( value => {
            let text = TextUtils.addTextByFamily(scene, value? value : this.formatUtilText(Tr('pusto')), 0, yy,
                value? textColor : '#d5d3d3', 15, 'normal', 300, Fonts.MYRIADPRO_REGULAR);
            text.visible = false;
            let optionBg = SpriteUtils.addSprite(scene, 0, yy, isGray? Keys.UI_LANG_BUTT_AVAL : Keys.ATLAS_UI,
                isGray? undefined : Keys.UI_BUTTON_BROWN, 1, isGray? 1 : 0.5);
            optionBg.visible = false;
            optionBg.alpha = value || isGray? 1: 0.5;

            self.options.set(value, text);
            self.optionsBg.set(value, optionBg);
            self.add([optionBg, text]);

            yy += isGray? optionBg.height + 10 : 25;

            optionBg.setInteractive().on('pointerup', function() {
                self.chosen = value;
                self.options.forEach( (text, key) => {
                   text.visible = false;
                });
                self.optionsBg.forEach( (bg, key) => {
                    bg.visible = false;
                });
                self.chooseButtonText.text = value? value :self.formatUtilText(Tr('vibrat'));
                self.chooseButtonText.setColor(value? '#98ff9f': '#d5d3d3');
                self.chooseButton.alpha = value || isGray? 1: 0.5;
                self.chooseButtonText.visible = true;
                self.chooseButton.visible = true;
                if(endChooseCallback) endChooseCallback();
            });
        });

    }

    private formatUtilText(value: string): string{
        return "--" + value.toLowerCase() + "--";
    }

    public getValue():string{
        return this.chosen;
    }

}
